import { getCustomerToken } from "../../features/customer/customer";
import store from "../../store/store";
import { StoreState } from "../../store/store.interface";

export function getDefaultHeaders() {
    return {
      'Content-Type': 'application/json'
    }
  }

export function getAuthenticationHeaders() {
    return {
      ...getDefaultHeaders(),
      Authorization: `Bearer ${getCustomerToken(store.getState() as StoreState)}`,
    }
  }